export class Accordion {
	init() {
		$('.lineup-acc-heading').on('click', function() {
			let $this = $(this),
				acc = $this.next('.features-list--homepage-bands.acc');

			if($this.hasClass('open')){
				acc.removeClass('open')
				$this.removeClass('open')
			}else{
				$this.addClass('open');
				acc.addClass('open');
			}
		})
	}
}